import React from 'react';
import './ServiceCard.css';

interface ServiceCardProps {
  icon: string;
  title: string;
  description: string;
  features: string[];
  featured?: boolean;
  featuredBadge?: string;
}

const ServiceCard: React.FC<ServiceCardProps> = ({
  icon,
  title,
  description,
  features,
  featured = false,
  featuredBadge = 'Most Popular',
}) => {
  return (
    <div className={`service-card ${featured ? 'featured' : ''}`}>
      {featured && <div className="featured-badge">{featuredBadge}</div>}
      <div className="service-icon">{icon}</div>
      <h3 className="service-title">{title}</h3>
      <p className="service-description">{description}</p>
      <ul className="service-features">
        {features.map((feature, index) => (
          <li key={index}>{feature}</li>
        ))}
      </ul>
    </div>
  );
};

export default ServiceCard;

